import {useEffect} from 'react'
import {useSelector} from 'react-redux'
import {QueryStatus} from '@reduxjs/toolkit/dist/query'
import {getCommonPaymentPageLandingParams} from 'modules/searchApi/selectors'
import Settings from 'Settings'

import {useBrand} from '@daedalus/core/src/_web/brand/hooks/useBrand'
import {parseUrl} from '@daedalus/core/src/_web/utils/url'
import {getDataFile} from '@daedalus/core/src/experiments/modules/selectors'
import {collectSapiVariationsParam} from '@daedalus/core/src/experiments/sapi'
import {
  buildOfferCheckEndpoint,
  OfferCheckedIn
} from '@daedalus/core/src/offer/business/buildOfferCheckEndpoint'
import {getOfferCheckApiRequestParams} from '@daedalus/core/src/offer/business/getOfferCheckApiRequestParams'
import {useLazyGetOfferCheckQuery} from '@daedalus/core/src/offer/services/offerCheckApi'
import {BaseUrlCheckoutParams} from '@daedalus/core/src/utils/url/types/UrlParams'
import {variationsToArray} from '@findhotel/sapi'

type Props = {
  offerParams: {
    roomId: string
    offerId?: string
    roomsBundleId?: string
    providerCode: string
    providerRateType: string
    cug: string
    offerPerks?: string
  }
  offerUrl: string
  clickHandler?: () => void
}

// for both, regular offer and split booking offer
export const useDefferedOfferInteraction = ({
  offerParams,
  offerUrl,
  clickHandler
}: Props) => {
  const commonPaymentPageParams = useSelector(getCommonPaymentPageLandingParams)
  const {brandCode} = useBrand()
  const env = Settings.get('APP_ENV')

  const {searchObject} = parseUrl(offerUrl)

  const dataFile = useSelector(getDataFile)

  const [triggerOfferCheckCall, {data, status}] = useLazyGetOfferCheckQuery()

  const defferedOfferClick = () => {
    /**
     * temporary way to build offer check url
     * TODO: improve this
     */
    const sapiVariations = collectSapiVariationsParam(
      dataFile?.featureFlags.map(({key}) => key)
    )
    const headers = {
      'x-sapi-variations': variationsToArray(sapiVariations).join(',')
    }
    const offerCheckUrl = buildOfferCheckEndpoint(
      {
        ...commonPaymentPageParams,
        ...offerParams,
        ...(searchObject as BaseUrlCheckoutParams),
        offerCheckedIn: OfferCheckedIn.AP_OFFER_CLICK
      },
      Settings.get('CLIENT_BOVIO_ENDPOINT')
    )

    triggerOfferCheckCall(
      getOfferCheckApiRequestParams(offerCheckUrl, brandCode, env, headers)
    )
  }

  useEffect(() => {
    if (status === QueryStatus.fulfilled && data && clickHandler) {
      clickHandler()
    }
  }, [status, data, clickHandler])

  return {
    defferedOfferClick
  }
}
